import { Trans } from "@lingui/react/macro";
import { Button, Modal, Tooltip } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconSend } from "@tabler/icons-react";

import { GetBookingData } from "@/shared/api/generated/schemas";

import SendBookingForm from "./send-booking-form";

export default function SendBooking({ booking }: { booking: GetBookingData }) {
  const [opened, { open, close }] = useDisclosure(false);

  const products = booking.program?.filter((p) => p.productID !== null) ?? [];

  const noProducts = products?.length === 0;
  const alreadySent = false;

  const shouldDisableSendButton = alreadySent || noProducts;

  return (
    <>
      <Tooltip
        label={
          alreadySent ? (
            <Trans>
              Bookingen er allerede sendt til PowerOffice og kan ikke sendes på
              nytt
            </Trans>
          ) : noProducts ? (
            <Trans>
              Bookingen må inneholde minst ett produkt for å kunne sendes til
              PowerOffice
            </Trans>
          ) : null
        }
        disabled={!shouldDisableSendButton}
      >
        <Button
          color="green"
          leftSection={<IconSend size={16} />}
          disabled={shouldDisableSendButton}
          onClick={open}
        >
          <Trans>Fakturer</Trans>
        </Button>
      </Tooltip>

      <Modal
        opened={opened}
        onClose={close}
        size="lg"
        title={<Trans>Send til fakturering</Trans>}
      >
        <SendBookingForm booking={booking} close={close} />
      </Modal>
    </>
  );
}
